import random from "lodash.random";

/**
 * 수학 표현식 생성기
 * @param {object} options
 * @param {number} options.level - 문제 수준 (0 ~ 2)
 */
export const generateExpression = options => {
  if (options.level === undefined)
    throw new Error("options.level must be specified!");

  const operators = ["+", "-", "*", "/"];
  const operator = operators[random(operators.length - 1)];
  const operands = buildOperands(operator, options.level);

  return operands.join(` ${operator} `);
};

/**
 * 연산항 생성
 * @param {string} operator - 연산자
 * @param {number} level - 문제 수준 (0 ~ 2)
 */
const buildOperands = (operator, level) => {
  let operands = [];

  const isDivision = operator === "/";

  switch (level) {
    case 0: {
      operands = operands.concat([random(1, 9), random(1, 9)]);
      break;
    }
    case 1: {
      if (operator == "*") {
        operands = operands.concat([random(10, 99), random(2, 10)]);
      } else {
        operands = operands.concat([random(10, 99), random(2, 99)]);
      }
      break;
    }
    case 2: {
      operands = operands.concat([
        random(100, 999),
        isDivision ? random(2, 9) : random(10, 49)
      ]);
      break;
    }
  }

  if (isDivision && !isModZero(operands[0], operands[1])) {
    while (!isModZero(operands[0], operands[1])) {
      operands = buildOperands(operator, level);
    }
  }

  return operands;
};

/**
 * 나눠떨어지는 수 판별
 * @param {number} numOne - 연산항
 * @param {number} numTwo - 연산항
 */
function isModZero(numOne, numTwo) {
  return numOne % numTwo === 0;
}
